// Central API helper that resolves base URL and safely parses responses

export const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export async function apiFetch(path, options = {}) {
	const url = `${API_BASE}${path}` || path; // if API_BASE empty, use relative path
	const res = await fetch(url, options);
	const contentType = res.headers.get("content-type") || "";
	const isJson = contentType.includes("application/json");
	let data;
	try {
		data = isJson ? await res.json() : await res.text();
	} catch {
		// non-parseable body
		data = null;
	}
	if (!res.ok) {
			const msg = isJson
			? (data && (data.error || data.message)) || `Request failed: ${res.status}`
			: typeof data === "string" && data.trim().startsWith("<!DOCTYPE")
				? "Unexpected HTML response from server. Check API base URL or proxy configuration."
				: (typeof data === "string" && data.slice(0, 200)) || `Request failed: ${res.status}`;
			const err = new Error(msg);
			err.status = res.status;
			err.body = data;
			err.isJson = isJson;
			throw err;
	}
	return data;
}

export function jsonHeaders(extra = {}) {
	return { "Content-Type": "application/json", ...extra };
}
